import { forwardRef, createElement } from 'react';

const VisuallyHidden = /*#__PURE__*/forwardRef(function VisuallyHidden(props, ref) {
  return createElement("span", Object.assign({}, props, {
    className: "sr-only",
    ref: ref
  }));
});

export { VisuallyHidden };
//# sourceMappingURL=VisuallyHidden.js.map
